import axios            from 'axios';
import authHeader       from 'services/auth-header';

class ChallengeEligibilityCheckerService  {
  toggleChallengeEligibility(id, params) {
    return axios
      .put(process.env.REACT_APP_API_ENDPOINT + 'chat_sessions/' + id + '/toggle_challenge_eligibility', params, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }
}

export default new ChallengeEligibilityCheckerService();